import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';

import { useLocale } from '$contexts/locale.jsx';
import { getLocation } from '$utilities/location';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ArticleShareButton = ({
    article
}) => {
    const { translate: t } = useLocale();
    const [isOpen, setIsOpen] = useState(false);
    const dialogRef = useRef();

    if (!article) { return null; }

    const location = getLocation();
    const url = location.href;
    const facebook = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    const twitter = `https://twitter.com/intent/tweet?url=${url}&text=`;
    const linkedin = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;

    const close = () => {
        if (dialogRef.current) {
            dialogRef.current.close();
        }
        clearAllBodyScrollLocks();
        setIsOpen(false);
    };

    const open = () => {
        if (dialogRef.current) {
            disableBodyScroll(dialogRef.current);
            dialogRef.current.showModal();
        }
        setIsOpen(true);
    };

    return (
        <>
            <button
                className='inline-block bg-orange text-white  rounded mr-10 type-style-7 px-20 py-15'
                onClick={open}
                type='button'>
                {t('Share')}
            </button>

            <dialog
                className='fixed top-50% left-50% z-10 w-370 bg-grey px-10 py-40 rounded'
                inert={isOpen ? null : ''}
                ref={dialogRef}>

                <button
                    aria-label='Close'
                    className='absolute top-0 right-0 p-20'
                    onClick={close}
                    type='button'>
                    <svg
                        style={{ width: '9px', height: '9px' }}
                        viewBox='0 0 9 9'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                            clipRule='evenodd'
                            d='M4.5 5.20709L8.0355 8.74259L8.74261 8.03548L5.20711 4.49999L8.74253 0.964562L8.03542 0.257456L4.5 3.79288L0.964431 0.25731L0.257324 0.964417L3.79289 4.49999L0.257249 8.03563L0.964355 8.74274L4.5 5.20709Z'
                            fill='black'
                            fillRule='evenodd' />
                    </svg>
                </button>

                <div className='text-center mb-10'>
                    <a
                        className='inline-block bg-orange text-white rounded type-style-7 px-20 py-15 w-100'
                        href={facebook}
                        rel='noreferrer'
                        target='_blank'>
                        {t('Facebook')}
                    </a>
                </div>
                <div className='text-center mb-10'>
                    <a
                        className='inline-block bg-orange text-white rounded type-style-7 px-20 py-15 w-100'
                        href={twitter}
                        rel='noreferrer'
                        target='_blank'>
                        {t('Twitter')}
                    </a>
                </div>
                <div className='text-center'>
                    <a
                        className='inline-block bg-orange text-white rounded type-style-7 px-20 py-15 w-100'
                        href={linkedin}
                        rel='noreferrer'
                        target='_blank'>
                        {t('LinkedIn')}
                    </a>
                </div>
            </dialog>
        </>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

const propTypes = {
    article: PropTypes.object,
};

ArticleShareButton.propTypes = propTypes;

export default ArticleShareButton;
